module.exports = __webpack_public_path__ + "img/9788946065451.933dfa4c.jpg";